<template>
	<div>
		<vs-prompt :active.sync="active" title="Re-Fare" accept-text="Done" v-on:accept="$emit('accept')">

			<div class="flex mb-6 p-3 items-center">
				<feather-icon
					:icon="result.icon ? result.icon : 'CircleIcon'"
					class="p-3 inline-flex rounded-full"
					:class="[`text-primary`]"
					:style="{ background: `rgba(var(--vs-primary),.15)` }"
				></feather-icon>
				<div class="ml-6">
					<h4 class="mb-2">{{ result.title }}</h4>
					<p v-html="result.description"></p>
				</div>
			</div>


			<vs-card class="my-6">
				<div class="flex items-center justify-between">
					<div>5 Nights South Caribbean</div>
					<div>
						<img
						src="/../cruise-line-logos/carnival.svg"
						class="max-w-full"
						width="24"
						style="max-height: 24px"/>
					</div>
					<div>
						Mar 11, 2022
					</div>
					<div>
						Suite
					</div>
					<div class="flex items-center">
						<span><span class="text-xl">$699&nbsp;</span> <span class="text-primary">-22%</span></span>
					</div>
				</div>
			</vs-card>

			<div class="text-center pt-6 px-6">
				<p class="font-bold">We are now forwarding you to your booking!</p>
				<div class="animation-wrapper mx-auto">
					<div class="animation"></div>
				</div>
				<p class="m-6 px-6">Please wait to be redirected. If nothing happens, please click <a href="#">this link</a> to continue.</p>
			</div>

		</vs-prompt>
	</div>
</template>


<script>
export default {
	data() {
		return {
			active: true,
		};
	},
	props: {
		result: {
			type: Object,
			required: true,
		},
	},
};
</script>
<style lang="scss">
	.animation-wrapper {
		border-bottom: 3px solid #E44A7F;
		width: 66%;
	}
	.animation {
		width: 100px; height: 100px;
		background-image: url(data:image/svg+xml;base64,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);
		background-size: 100%;
  		background-repeat: no-repeat;
		background-position-y: 27px;
		background-position-x: left;
		animation-name: MOVE-BG;
  		animation-duration: 5s;
  		animation-timing-function: linear;
  		animation-iteration-count: infinite;
	}
	@keyframes MOVE-BG {
		from {
			transform: translateX(-10%);
		}
		to {
			transform: translateX(260%);
		}
	}
</style>
